import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MarketingHome } from './pages/MarketingHome';
import { PortalHome } from './pages/PortalHome';
import { QuickPayFlow } from './pages/QuickPayFlow';
import { LoginPayFlow } from './pages/LoginPayFlow';
import { AdminLayout } from './pages/admin/AdminLayout';
import { Dashboard } from './pages/admin/Dashboard';
import { Consumers } from './pages/admin/Consumers';
import { Payments } from './pages/admin/Payments';
import { Offers } from './pages/admin/Offers';
import { Communications } from './pages/admin/Communications';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<MarketingHome data-id="element-3" />} data-id="element-2" />
        <Route path="/portal" element={<PortalHome data-id="element-5" />} data-id="element-4" />
        <Route path="/portal/quick-pay" element={<QuickPayFlow data-id="element-7" />} data-id="element-6" />
        <Route path="/portal/sign-in" element={<LoginPayFlow data-id="element-9" />} data-id="element-8" />
        <Route path="/portal/admin" element={<AdminLayout data-id="element-11" />} data-id="element-10">
          <Route index element={<Dashboard data-id="element-13" />} data-id="element-12" />
          <Route path="consumers" element={<Consumers data-id="element-15" />} data-id="element-14" />
          <Route path="payments" element={<Payments data-id="element-17" />} data-id="element-16" />
          <Route path="offers" element={<Offers data-id="element-19" />} data-id="element-18" />
          <Route path="communications" element={<Communications data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </BrowserRouter>;
}